import React, { useState } from 'react';
import { Icon, Menu } from 'semantic-ui-react';
import FileUpload from './FileUpload';
import FileList from './FileList';
import SidebarWrapper from './SidebarWrapper';

const FileShareBar = ({ getApiHeaders, onClose, isMobile, sidebarConfig, onHeightChange }) => {
  const [activeView, setActiveView] = useState('list'); // 'list' or 'upload'
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleUploadSuccess = () => {
    // Trigger refresh of file list
    setRefreshTrigger((prev) => prev + 1);
    // Switch to list view to show the uploaded file
    setTimeout(() => setActiveView('list'), 2000);
  };

  return (
    <SidebarWrapper
      isMobile={isMobile}
      sidebarConfig={sidebarConfig}
      onClose={onClose}
      onHeightChange={onHeightChange}
      zIndex={500}
    >
      {/* Header */}
      <div style={{
        padding: '15px 20px',
        borderBottom: '1px solid #ddd',
        background: '#f8f8f8'
      }}>
        <h2 style={{ margin: 0, fontSize: '1.3em', fontWeight: '600' }}>
          <Icon name="share alternate" />
          File Sharing
        </h2>
      </div>

      {/* Tab Menu */}
      <Menu attached="top" tabular style={{ margin: '0', borderBottom: 'none', backgroundColor: '#fff' }}>
        <Menu.Item
          name="list"
          active={activeView === 'list'}
          onClick={() => setActiveView('list')}
        >
          <Icon name="list" />
          My Files
        </Menu.Item>
        <Menu.Item
          name="upload"
          active={activeView === 'upload'}
          onClick={() => setActiveView('upload')}
        >
          <Icon name="cloud upload" />
          Upload New
        </Menu.Item>
      </Menu>

      {/* Scrollable Content */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '15px 20px',
        minHeight: 0
      }}>
        {activeView === 'upload' ? (
          <FileUpload getApiHeaders={getApiHeaders} onUploadSuccess={handleUploadSuccess} />
        ) : (
          <FileList getApiHeaders={getApiHeaders} refreshTrigger={refreshTrigger} />
        )}
      </div>
    </SidebarWrapper>
  );
};

export default FileShareBar;
